import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const Container = styled.div`
  min-height: 40px;
  min-width: 40px;
  border-radius: 50%;
  background-color: ${colors.primary};
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Title = styled.div`
  color: ${colors.titleStrongWhite};
  font-size: 14px;
`
